<link href="./logout-dialog.scss" rel="stylesheet">

<div class="warning-icon">
  <i class="fa-solid fa-triangle-exclamation"></i>
</div>

<h2 mat-dialog-title>Are you sure you want to logout?</h2>

<mat-dialog-actions>
  <button matButton mat-dialog-close class="btn generate-btn cancel-button">Cancel</button>
  <button matButton mat-dialog-close cdkFocusInitial class="btn btn-danger generate-btn logout-button"
    (click)="onLogout()">Logout</button>
</mat-dialog-actions>